const initialState = {
  data: null,
  getLoading: false,
  updateLoading: false,
  error: null,
};

const paymentMethodManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLEAR_REDUCERS":
      return initialState;

    case "GET_ORDER_PAYMENT_METHODS":
      return {
        ...initialState,
        getLoading: true,
      };

    case "GET_ORDER_PAYMENT_METHODS_SUCCESS":
      return {
        ...state,
        data: action.data,
        getLoading: false,
        error: null,
      };

    case "GET_ORDER_PAYMENT_METHODS_FAILURE":
      return {
        ...state,
        getLoading: false,
        error: action.error,
      };

    case "EDIT_ORDER_PAYMENT_METHOD":
      return {
        ...state,
        updateLoading: true,
        error: null,
      };
    case "EDIT_ORDER_PAYMENT_METHOD_SUCCESS":
      return {
        ...state,
        updateLoading: false,
        error: null,
      };
    case "EDIT_ORDER_PAYMENT_METHOD_FAILURE":
      return {
        ...state,
        updateLoading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default paymentMethodManagementReducer;
